if (!customElements.get('nap-collection-description')) {
  customElements.define('nap-collection-description', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const content = this.querySelector('.collection-description');
      const button = this.querySelector('button');
      const children = Array.from(content.children);
      // Keep complete paragraphs visible. On the reference collection, the
      // preview ends at the first h3, just before the remaining buying guide.
      const heading = children.findIndex(element => element.tagName === 'H3');
      const split = heading >= 0 ? heading + 1 : Math.min(6, children.length);
      const remaining = children.slice(split);
      if (!remaining.length) return;
      const setExpanded = expanded => {
        remaining.forEach(element => { element.hidden = !expanded; });
        button.setAttribute('aria-expanded', String(expanded));
        button.querySelector('[data-more]').hidden = expanded;
        button.querySelector('[data-less]').hidden = !expanded;
      };
      setExpanded(false);
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        setExpanded(expanded);
        if (!expanded) button.scrollIntoView({ block: 'nearest' });
      });
    }
  });
}
